/* GENERATED from design-system — edit there, then npm run copy:tokens */
/* club neuro motion engine — dependency-free.
   Scroll-reveal animations were removed by user decision (2026-07-19):
   [data-lp-reveal]/[data-lp-stagger] attributes in sections are inert and
   content is always visible. This engine powers two things:
     data-lp-counter="12000" on a number element (fires when scrolled into
     view; static server-rendered text is the no-JS/reduced-motion state);
     data-lp-autoplay on a <video> (starts a muted decorative loop ONLY when
     the visitor has not asked for reduced motion — see below). */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const countUp = (el) => {
    const target = parseFloat(el.dataset.lpCounter);
    if (!Number.isFinite(target)) { el.textContent = el.dataset.lpCounter; return; }
    const fmt = new Intl.NumberFormat();
    if (reduced) { el.textContent = fmt.format(target); return; }
    const dur = 1200, t0 = performance.now();
    const tick = (t) => {
      const p = Math.min((t - t0) / dur, 1);
      el.textContent = fmt.format(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  /* Decorative looping video — data-lp-autoplay on a <video>.
     WHY THIS IS JS AND NOT AN `autoplay` ATTRIBUTE. prefers-reduced-motion is
     a client fact; Liquid renders on the server and cannot branch on it, and
     CSS can style a <video> but cannot pause one. So the tag ships WITHOUT
     autoplay and this starts it. The consequences are all the right way
     round: reduced motion gets a still poster, no-JS gets a still poster,
     and with preload="none" neither downloads a single byte of video.
     The play() promise is caught because a browser may still refuse
     (low-power mode, a not-yet-muted element); a refusal must leave the
     poster up, not throw. */
  const autoplay = () => {
    for (const v of document.querySelectorAll('video[data-lp-autoplay]:not([data-lp-autoplayed])')) {
      v.dataset.lpAutoplayed = 'true';
      if (reduced) { v.pause(); continue; }
      v.muted = true; // iOS refuses to autoplay unless the PROPERTY is set
      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }
  };

  const init = () => {
    autoplay();
    const targets = document.querySelectorAll('[data-lp-counter]:not([data-lp-counted])');
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach((el) => { el.dataset.lpCounted = 'true'; countUp(el); });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.dataset.lpCounted = 'true';
        countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((el) => io.observe(el));
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  /* Shopify theme editor re-renders sections in place; re-run init so
     counters inside the re-rendered section still fire. The
     data-lp-counted guard keeps re-runs idempotent. */
  document.addEventListener('shopify:section:load', init);
})();
